import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Facet } from 'src/app/models/facet-model';
import { SearchOutputModel } from 'src/app/models/search-output-model';
import { SearchResultsModel } from 'src/app/models/search-results-model';
import { FormsService } from 'src/app/services/forms.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QueryStateService } from 'src/app/services/query-state.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { SearchComboItemModel } from 'src/app/models/search-combo-item-model';
import { MetadataProp } from 'src/app/models/metadata-prop-model';
import { environment } from 'src/environments/environment';
import { AnnouncementModel } from 'src/app/models/announcement-model';
import { AnnouncementsService } from 'src/app/services/announcements.service';
@Component({
  selector: 'app-home-clean-view',
  templateUrl: './home-clean-view.component.html',
  styleUrls: ['./home-clean-view.component.css']
})
export class HomeCleanViewComponent implements OnInit {

  @Input() query?: string;

  searchForm: FormGroup;
  loading = false;
  datesVisible = true;
  tableCols: any[] = [];
  defaultTableColumns = ["DocumentTitle", "DateAdded", "DocumentDate"];
  dateSearchValue = '';
  mdItems?: MetadataProp[];
  showLoadSearch:boolean = false;

  searchOutput?: SearchOutputModel;
  searchResults: SearchResultsModel[] = []; //Complete list of results retrieved from the search
  viewItems: SearchResultsModel[] = []; // item shown on screen and in the table based on the page and pageSize
  facets?: Facet;

  totalCount: number = 0;
  qs?: string | null = '';
  routeLink: string = '';
  editSearchValues: any;
  pageSize: number = 25;
  first: number = 0;
  showSortReset: boolean = false;
  announcements: AnnouncementModel[] =[];

  constructor(private formSvc: FormsService, private actRouter: ActivatedRoute,
    private router: Router, private titleSvc: Title, private loaderService: LoaderService,
    private queryStateSvc: QueryStateService,
    private constants: ConstantsService) {
    this.titleSvc.setTitle(environment.site_name + ' - Home');
    this.searchForm = this.formSvc.initSearchForm();
  }

  ngOnInit(): void {
    this.subscribeLoader();
    // this.loadAnnouncements();
    this.actRouter.data.subscribe((d: any) => {
      this.mdItems = d.metadataProps;
      this.announcements = d.announcements;
    });
  }

  subscribeLoader() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

  executeQuickDateSearch(startDate: string, endDate?: string) {
    let dateOp = this.constants.date_operator_equals;
    if (endDate) {
      dateOp = this.constants.date_operator_between;
    }

    //get the property Item Id
    let i = this.mdItems?.find((m) => m.cogSearchKey == 'DateAdded') as MetadataProp;
    let pid = '';
    if (i) { 
      pid = i.id;
    }

    let data: SearchComboItemModel = {
      isDate: true,
      dateOperator: dateOp,
      displayName: "Date Added",
      propertyItem: pid, 
      endDate: endDate,
      startDate: startDate,
      keywords: ''
    };


    let p = this.formSvc.updateDateProp(data);

    const allArray = this.searchForm.get(this.constants.property_operator_all) as FormArray;
    allArray.clear();  // Clear the other items since we are using a pre-canned query.
    allArray.push(p);

    // Update the form values in the query state service which drives functions
    this.queryStateSvc.updateFormData(this.searchForm.value); // Will update/create the Search request in the Query Service.

    this.router.navigate([
      '/results/' + encodeURIComponent(JSON.stringify(this.queryStateSvc.getFormData())),
    ]);
  }

  searchDays(daysBack: number) {
    let d = new Date();
    const finalDate = new Date(d);
    finalDate.setDate(d.getDate() - daysBack);

    let start = finalDate.toISOString().substring(0, 10);
    let end = d.toISOString().substring(0, 10);

    // If today or yesterday then just use the one date which will use equals operator.
    if (daysBack < 2) {
      this.executeQuickDateSearch(start);
    }
    else {
      this.executeQuickDateSearch(start, end);
    }
  }

  // loadAnnouncements(){
  //  this.announcementSvc.getTodayAnnouncements().subscribe((d: any) => {
  //   this.announcements = d;
  //  });
  // }
}
